(function () {
    'use strict';

    var module = angular.module('uwAgenda.programinfo');
    module.factory('ProgramInfo', [ProgramInfoFactoryFn]);


    function ProgramInfoFactoryFn() {
        var ProgramInfo = function () {
            this.programInfoTitle = null;
            this.programInfoSubTitle = null;
            this.programInfoHyperLink = null;
            this.programInfoContent = null;
            
        };

        return ProgramInfo;
    }

})();